import React, { Children } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import virtualListPropType from '../virtual-list/virtual-list-prop-type'
import OptionList from './option-list'

import styles from './select.module.css'

const propTypes = {
    className: PropTypes.string,
    list: PropTypes.element,
    multiple: PropTypes.bool,
    onChange: PropTypes.func,
    open: PropTypes.bool,
    placement: PropTypes.oneOf(['top', 'bottom']),
    selectedIndices: PropTypes.arrayOf(PropTypes.number),
    virtual: virtualListPropType
}

const defaultProps = {
    onChange: () => {},
    placement: 'bottom',
    selectedIndices: []
}

function SelectOptionList(props) {
    const { children, className, list, multiple, onChange, open, placement, selectedIndices, virtual } = props
    const mergedClassName = cx(
        styles['select-option-list'],
        {
            [styles['list-open']]: open,
            [styles['placement-bottom']]: placement === 'bottom',
            [styles['placement-top']]: placement === 'top'
        },
        className,
        't3sel-select-option-list'
    )

    const listItems = Children.toArray(children)
        .filter(Boolean)
        .map((child, index) => {
            const { changeEvent, disabled, selectable, selectionProp } = child.props
            const selected = selectedIndices.indexOf(index) !== -1
            return React.cloneElement(child, {
                [selectionProp || 'selected']: selected,
                [changeEvent || 'onClick']: () => {
                    if (!disabled && selectable) {
                        const newSelectedIndices = getSelectedIndices(index, multiple, selectedIndices)
                        onChange(newSelectedIndices)
                    }
                }
            })
        })

    return (
        <div className={mergedClassName}>
            {list ? (
                React.cloneElement(list, { open }, listItems)
            ) : (
                <OptionList {...{ open, placement, virtual }}>{listItems}</OptionList>
            )}
        </div>
    )
}

/**
 * Event handler - handle Option onClick.
 *
 * @param {Number}  clickedIndex - index of the Option component that was clicked.
 * @param boolean   multiple if the select list is multi-select
 * @param [Number)  selectedIndices - indices of the Option component that was already selected.
 * @returns {Array} Returns `array`.
 */
function getSelectedIndices(clickedIndex, multiple, selectedIndices) {
    let newSelectedIndices = selectedIndices.slice()

    if (multiple) {
        if (selectedIndices.indexOf(clickedIndex) !== -1) {
            newSelectedIndices = selectedIndices.filter(index => index !== clickedIndex)
        } else {
            newSelectedIndices.push(clickedIndex)
        }
    } else {
        newSelectedIndices = [clickedIndex]
    }
    return newSelectedIndices
}

SelectOptionList.propTypes = propTypes
SelectOptionList.defaultProps = defaultProps

export default SelectOptionList
